<script>
import Breadcrumbs from '../../components/Breadcrumbs/index.vue'
import LoginComponent from '../../components/Login/index.vue'

export default {
    name: 'Login' ,
    components:{
        Breadcrumbs,
        LoginComponent
    }
}
</script>
<template src = "./template.html"></template>